import { CloudWatchWidget } from "./types";

export function widget(title: string, region: string, metrics: (string | object)[][], x = 0, y = 0, width = 24, height = 8): CloudWatchWidget {
  return {
      type: 'metric',
      x: x,
      y: y,
      width: width,
      height: height,
      properties: {
          region: region,
          title: title,
          period: 60,
          view: "timeSeries",
          stacked: false,
          metrics: metrics,
          yAxis: {
            left: {
              min: 0
            },
            right: {
              min: 0
            }
          }
      },
  }
}
